import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";

/**
 * Returns true when the shop is on the "mini" retraction-portal plan.
 * On this plan, only refunds are allowed and transport/carrier features are hidden.
 */
export function useIsRetractionOnly(): boolean {
  const { data: shop } = useCurrentShopSuspense();
  return !!shop?.plan.retractionPortal;
}
